import fetchApi from "../fetchApi";

/**
 * Returns an array of report methods.
 *
 * @returns {array} An array of objects, with each object containing a value and label.
 * The value is the report method's value, and the label is the report method's label.
 */
export const GetReportMethods = async (program) => {
  const { company_id } = JSON.parse(localStorage.getItem("auth_user_data"));
  try {
    const options = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      redirect: "follow",
    };

    return await fetchApi(
      `card-issuing/company/program-report/reporting-methods?program_id=${program}&company_id=${company_id}`,
      options
    );
  } catch (error) {
    console.error("Error fetching report types:", error);
    return error;
  }
};
